import { useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import {
    useCityLedgerFilterContext,
    useCityLedgerPagination,
    useCityLedgerSelectedDate,
} from '../context/CityLedgerFilterContext';
import { transformAccountsData } from '../utils/transformAccountsData';
import { getOwnerType } from '../utils/getOwnerType';
import { getAgeingType } from '../utils/getAgeingType';

export const useCityLedgerBalances = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const { pagination } = useCityLedgerPagination();
    const { filterValues } = useCityLedgerFilterContext();
    const { selectedDate } = useCityLedgerSelectedDate();
    const { searchQuery, ownerTypes, ageing } = filterValues;
    const ownerTypesArray = getOwnerType(ownerTypes ?? []);

    return useRepositoryQuery(
        'cityLedger',
        'balances',
        {
            enterpriseId,
            localDateOnly: selectedDate,
            count: pagination.pageSize,
            startIndex: pagination.pageIndex * pagination.pageSize,
            ...(searchQuery ? { searchToken: searchQuery } : {}),
            ownerTypesArray,
            ageingTypes: getAgeingType(ageing ?? []),
        },
        {
            enabled: !!enterpriseId,
            select: (data) => transformAccountsData(data),
            staleTime: 5000,
            refetchOnMount: true,
            refetchInterval: 60000, // Refetch every 60 seconds
        }
    );
};
